import { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  API,
  GlobalActions,
  CompanySelection,
  VibeButton,
  VibeIcon,
  viClose,
  color,
} from 'vibeguide';

function MessageCompanies({
  allowChanges,
  companies: propCompanies = [],
  partnerId = '',
  mediaFormat,
  onUpdateVisualFileList = () => {},
  newVisualFiles = [],
  setPanel,
  onUpdate = () => {},
}) {
  const [companies, setCompanies] = useState(propCompanies);

  const isACAF = companies.length === 1 && companies[0]._id === '*';

  /**
   * When the companies are changed
   */
  const onChange = (companies) => {
    setCompanies(companies);

    onUpdate({
      locations: companies.map(company => {
        return {
          companyId: company._id,
          locationId: '*',
        };
      }),
      locationsData: {
        companies: companies.map(company => {
          return {
            ...company,
            locations: [],
            locationCount: '*',
          };
        }),
        locations: [],
      },
    });
  };

  /**
   * Close the third panel on the sidebar
   */
  const onCloseAvailable = () => {
    setPanel({
      thirdPanel: {
        show: false,
      },
    });

    // Reset the children after it's been hidden
    setTimeout(() => {
      setPanel({
        thirdPanel: {
          children: null,
        },
      });
    }, 900);
  };

  const onClickAssign = () => {
    setPanel({
      thirdPanel: {
        width: window.innerWidth,
        show: true,
        children: (
          <CompanySelection
            selected={companies}
            partnerId={partnerId}
            customToolbar={(
              <VibeIcon
                icon={viClose}
                color={color.white}
                hoverColor={color.white}
                size={24}
                onClick={onCloseAvailable}
              />
            )}
            assigning
            allowChanges
            onChange={onChange}
          />
        ),
      },
    });
  };

  const onClose = async () => {
    setPanel({
      extraPanel: {
        show: false,
      },
    });

    // Reset the children after it's been hidden
    setTimeout(() => {
      setPanel({
        extraPanel: {
          children: null,
        },
      });
    }, 900);

    if (mediaFormat === 'visual') {
      const locations = companies.map(company => {
        return {
          companyId: company._id,
          locationId: '*',
        };
      });

      const locationResolutions = companies.length > 0 ? await API.Location.resolutions({
        locations,
      }) : [];

      // Remove visual uploads that no longer apply
      const filteredVisualFiles = newVisualFiles.filter((file) => {
        const hasMatch = locationResolutions.some((resolution) => {
          if ((file.targetScreen.resolution[0] === resolution.size[0])
            && (file.targetScreen.resolution[1] === resolution.size[1])) {
            return true;
          } return false;
        });
        return hasMatch;
      });

      onUpdate({
        resolutions: locationResolutions,
      });
      onUpdateVisualFileList({
        newVisualFiles: filteredVisualFiles,
      });
    }
  };

  return (
    <CompanySelection
      selected={companies}
      customToolbar={(
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          {allowChanges && !isACAF && (
            <VibeButton
              text="Assign Companies"
              color="primary"
              onClick={onClickAssign}
            />
          )}

          <VibeIcon
            className="close"
            icon={viClose}
            color={color.manatee}
            hoverColor={color.obsidian}
            size={24}
            onClick={onClose}
          />
        </div>
      )}
      allowChanges={allowChanges}
      allowACAF={false}
      onChange={onChange}
    />
  );
}

MessageCompanies.propTypes = {
  companies: PropTypes.arrayOf(PropTypes.object),
  partnerId: PropTypes.string,
  onUpdateVisualFileList: PropTypes.func,
  newVisualFiles: PropTypes.arrayOf(PropTypes.object),
  /** Allow changes to the selection */
  allowChanges: PropTypes.bool,
  onUpdate: PropTypes.func,
};

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default connect(null, mapDispatchToProps)(MessageCompanies);
